"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundImage = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const NotFoundImage = () => /*#__PURE__*/React.createElement("svg", {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.6144 41.3329C98.6144 51.4876 90.5389 59.8847 80.4937 60.4706C80.0994 60.4706 79.7055 60.4706 79.3115 60.4706C75.9631 60.4706 72.6146 59.4941 69.8571 57.9319C63.948 54.6121 60.0087 48.3631 60.0087 41.1376C60.0087 36.2556 61.7813 31.7641 64.9329 28.4443C68.4783 24.5387 73.5994 22 79.3115 22C86.7961 22 93.296 26.2962 96.448 32.5453C97.8261 35.2791 98.6144 38.2084 98.6144 41.3329Z",
  fill: "#F1F1F5",
  stroke: "#D3D2E0",
  strokeWidth: "1.6185",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  opacity: "0.1",
  d: "M98.4453 41.333C98.4453 51.4876 90.3698 59.8848 80.324 60.4706C76.5817 59.8848 73.0363 58.9083 69.6877 58.1273C63.7788 54.8074 59.8394 48.5584 59.8394 41.333C59.8394 36.4509 61.6121 31.9595 64.7636 28.6396C71.2635 28.4444 78.7483 29.0302 86.4304 30.3971C89.9757 30.983 93.3236 31.7641 96.4756 32.5453C97.6571 35.2793 98.4453 38.2085 98.4453 41.333Z",
  fill: "#AAB2C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.996 54.2571C123.483 45.9751 105.154 35.8147 81.0569 31.5632C56.9605 27.3117 36.2211 30.5791 34.7345 38.8611C33.248 47.1431 51.5771 57.3036 75.6738 61.555C99.7708 65.8065 120.509 62.5391 121.996 54.2571Z",
  fill: "#F1F1F5",
  stroke: "#D3D2E0",
  strokeWidth: "1.6185",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.9142 36.2923C75.0239 34.8945 72.8268 33.5851 70.0069 33.3677C67.1871 33.1503 64.8122 34.1073 64.7027 35.5052C64.593 36.9031 66.7901 38.2124 69.6099 38.4298C72.4298 38.6472 74.8046 37.6902 74.9142 36.2923Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.1303 39.8824C52.8416 39.0843 54.7132 37.3478 54.3107 36.0038C53.9083 34.6598 51.3841 34.2172 48.6729 35.0152C45.9616 35.8133 44.0899 37.5498 44.4925 38.8938C44.8949 40.2379 47.4191 40.6805 50.1303 39.8824Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.8344 41.4304C95.082 40.0501 93.0257 38.5328 90.2411 38.0415C87.4564 37.5502 84.9979 38.2709 84.7503 39.6513C84.5027 41.0316 86.559 42.5489 89.3436 43.0402C92.1282 43.5315 94.5859 42.8107 94.8344 41.4304Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.787 51.6409C110.435 50.3948 108.923 48.3428 106.409 47.0577C103.895 45.7725 101.332 45.7409 100.684 46.9871C100.035 48.2333 101.548 50.2853 104.061 51.5704C106.576 52.8555 109.139 52.8871 109.787 51.6409Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.709 118.008H19.9669C22.5275 115.713 26.2699 113.418 30.6032 111.696C32.9669 110.836 35.7244 109.689 38.482 109.115C46.7546 106.82 56.7999 105.386 67.4362 105.386C80.2392 105.386 92.057 107.393 101.118 110.549C104.269 111.696 107.026 112.844 109.39 114.279C111.557 115.425 113.33 116.573 114.709 118.008Z",
  fill: "#F1F1F5",
  stroke: "#D3D2E0",
  strokeWidth: "1.6185",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.4375 111.487C39.5616 112.652 37.5312 114.047 35.1809 114.297C32.8306 114.547 30.7686 113.785 30.4486 112.641C32.7368 111.808 35.3962 110.739 38.0968 110.059C38.9217 110.364 39.3754 110.904 39.4375 111.487Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.4062 109.682C59.5609 109.682 62.1183 109.07 62.1183 108.315C62.1183 107.56 59.5609 106.948 56.4062 106.948C53.2515 106.948 50.6941 107.56 50.6941 108.315C50.6941 109.07 53.2515 109.682 56.4062 109.682Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.1958 109.569C87.2606 108.601 84.7608 107.648 81.6128 107.441C78.4655 107.235 75.8613 107.852 75.7965 108.82C75.7318 109.789 78.231 110.742 81.379 110.948C84.5261 111.156 87.1311 110.538 87.1958 109.569Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.376 114.613C107.593 114.523 106.653 114.553 105.502 114.223C102.394 113.668 99.9617 112.405 100.073 111.436C100.096 111.241 100.096 111.241 100.314 111.07C103.355 112.207 106.119 113.307 108.376 114.613Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.6705 55.4708C97.3373 51.7545 89.0223 47.1794 78.0986 45.2521C67.1748 43.3247 57.7785 44.775 57.1115 48.4912C56.4444 52.2075 64.7592 56.7826 75.683 58.7099C86.6067 60.6373 96.0029 59.187 96.6705 55.4708Z",
  fill: "#9F9FBC",
  stroke: "#D3D2E0",
  strokeWidth: "1.6185",
  strokeMiterlimit: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9393 73.4683C25.9393 73.4683 19.1354 75.1958 21.1972 76.5777C23.259 77.8906 28.1385 80.1709 32.7431 78.6507C37.3478 77.1305 32.7431 74.9884 32.8119 74.9884C32.8806 74.9884 25.9393 73.4683 25.9393 73.4683Z",
  fill: "#E6E5EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6233 72.9157C20.0974 73.6758 27.726 72.432 32.6056 69.2534C36.4542 74.0213 37.8975 75.2651 39.272 75.4032C37.1415 77.5453 30.0627 81.0003 26.0766 76.5088C21.4032 79.4801 17.6233 72.9157 17.6233 72.9157Z",
  fill: "#F1F1F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138 118.008H132.093H9.6315H2",
  stroke: "#D3D2E0",
  strokeWidth: "1.6185",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.8776 48.037L58.0795 48L30 117.873L104 129L95.58 56L74.8776 48.037Z",
  fill: "url(#paint0_linear_1872_702)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.3451 79.1355C101.957 79.2738 109.036 76.0952 112.884 71.811C117.832 75.4733 119.482 76.3025 120.925 76.0952C119.344 78.721 114.534 84.4562 107.73 84.8708C102.781 81.9686 99.3451 79.1355 99.3451 79.1355Z",
  fill: "#F1F1F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.7118 79.2211C76.1951 76.6574 71.3534 70.5935 66.2456 67.9333C68.5599 62.2288 68.9521 60.4248 68.3918 59.0786C71.3285 59.9554 78.0814 63.186 80.1777 69.6722C78.5996 75.1874 76.7118 79.2211 76.7118 79.2211Z",
  fill: "#F1F1F5"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1872_702",
  x1: "78.5",
  y1: "51",
  x2: "67.9138",
  y2: "96.4599",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9F9FBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#D3D2E0",
  stopOpacity: "0"
}))));
exports.NotFoundImage = NotFoundImage;